"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var _default = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The name of the icon to display from the icons map. */
  name: _propTypes.default.string.isRequired,

  /** The ARIA role attribute. */
  role: _propTypes.default.string,

  /** The dimensions to set the width and height of the icon to. */
  size: _propTypes.default.number,

  /** Additional key/value pairs for the icon names/path definitions to add on to the common set provided. */
  iconDefinitions: _propTypes.default.object
};
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Icon/IconPropTypes.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();